import * as React from 'react';
import SidebarLink from './sidebar-link';
import {RouteComponentProps, withRouter} from 'react-router';
import {connect} from 'react-redux';

interface SidebarContentProps {
    onClick();
}

class SidebarContent extends React.PureComponent<SidebarContentProps & RouteComponentProps<any>> {

    private hideSidebar = () => {
        this.props.onClick();
    };

    public render() {
        return (
            <div className='sidebar__content'>
                <ul className='sidebar__block'>
                    <SidebarLink title='Portada' icon='laptop' route='/home' onClick={this.hideSidebar}/>
                    <SidebarLink title='Liquidación' icon='book' route='/liquidacion' onClick={this.hideSidebar}/>
                    <SidebarLink title='Almacén' icon='book' route='/almacen' onClick={this.hideSidebar}/>
                    <SidebarLink title='Reporte Comprobantes' icon='book' route='/comprobantes' onClick={this.hideSidebar}/>
                </ul>
            </div>
        )
    }
}

export default withRouter(connect(null, null, null, {
    pure: false
})(SidebarContent));


// WEBPACK FOOTER //
// ./src/components/common/layout/sidebar/sidebar-content.tsx